import { render, staticRenderFns } from "./TemplateDialog.vue?vue&type=template&id=bcc77a82"
import script from "./TemplateDialog.vue?vue&type=script&lang=js"
export * from "./TemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateDialog.vue?vue&type=style&index=0&id=bcc77a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports